/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Store/StorePermissionService',[
    'jquery',
    'lodash',
    'global/Core',
    'global/Extensions',
    'global/Logger'
], function ($, _, Core, Extensions, Logger) {
    'use strict';

    function clearCookies() {
        Core.eraseCookie('is_oem');
        Core.eraseCookie('can_see_pricing');
        Core.eraseCookie('can_place_order');
        Core.eraseCookie('is_approved_b2b');
    }

    function isLoggedIn() {
        return Core.getCookie('access_token') !== null;
    }

    function isApprovedB2BUser() {
        return Core.getCookie('is_approved_b2b') === 'True';
    }
    /**
     * Determines whether the current user can see product pricing.
     * Pricing is available for b2b approved users only.
     * @returns {} 
     */
    function canSeePricing() {
        return Core.getCookie('can_see_pricing') === 'True';
    }

    function canPlaceOrder() {
        return Core.getCookie('can_place_order') === 'True';
    }

    function isOem() {
        return Core.getCookie('is_oem') === 'True';
    }

    var StorePermissionService = {
        isLoggedIn: isLoggedIn,
        isApprovedB2BUser: isApprovedB2BUser,
        canSeePricing: canSeePricing,
        canPlaceOrder: canPlaceOrder,
        isOem: isOem,
        clearCookies: clearCookies
    };

    Logger.debug('StorePermissionService.js Loaded:', StorePermissionService);

    return StorePermissionService;
});
